export type GalleryItem = {
  type: "image" | "video";
  src: string;
};

export type ResearchProject = {
  id: number;
  titleKey: string;
  titleText: string;
  descriptionKey: string;
  descriptionText: string;
  imageSrc: string;
  showButton: boolean;
  category: string;
  members?: string[];
  gallery?: GalleryItem[];
  projectType: "tesis" | "investigacion" | "interes" | "nacional" | "internacional" | "academia";
};

export const projects: ResearchProject[] = [

    {
    id: 17,
    titleKey: "mayanchip1_proj_title",
    titleText: "Maya on Chip: Iniciativa Estratégica de Semiconductores",
    descriptionKey: "mayanchip1_proj_desc",
    descriptionText: "Programa estratégico de formación y certificación en semiconductores, automotriz e IA en Yucatán.",
    imageSrc: "./img/researchLines/MayanOnChip/clausura2026/27.jpg",
    showButton: false,
    category: "SEMICONDUCTORES · FORMACIÓN",
    members: ["Alejandro Castillo Atoche"],
    projectType: "academia",
    gallery: [
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/1.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/2.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/3.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/4.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/5.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/6.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/7.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/8.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/9.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/10.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/11.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/12.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/13.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/14.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/15.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/16.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/17.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/18.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/19.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/20.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/21.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/22.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/23.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/24.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/25.jpg" },
      { type: "image", src: "./img/researchLines/MayanOnChip/clausura2026/26.jpg" },
    ],
  },
  {
  id: 18,
    titleKey: "domo_proj_title",
    titleText: "Domo Digital Inteligente: Monitoreo Ambiental para Ciudades Inteligentes",
    descriptionKey: "domo_proj_desc",
    descriptionText: "Red inalámbrica de sensores autónomos LoRaWAN para monitoreo ambiental en tiempo real del Centro Histórico de Mérida.",
    imageSrc: "./img/researchLines/DomoDigital/1.jpg",
    showButton: false,
    category: "CIUDADES INTELIGENTES · IOT AMBIENTAL",
    members: ["Renán Quijano"],
    projectType: "nacional",
    gallery: [
      { type: "image", src: "./img/researchLines/domo_digital_2.jpg" },
    ],
  },
  {
  id: 19,
    titleKey: "francia_proj_title",
    titleText: "Doble titulacion posgrado UADY-UCA: PhD Université de Clermont Auvergne",
    descriptionKey: "francia_proj_desc",
    descriptionText: "Programa de doble titulación entre la Universidad Autónoma de Yucatán y la Universidad de Clermont Auvergne.",
    imageSrc: "./img/researchLines/Francia/1.webp",
    showButton: false,
    category: "DOBLE TITULACIÓN · INTERNACIONAL",
    members: ["Yumil Rueda", "Andrea Garma"],
    projectType: "internacional",
    gallery: [
      { type: "image", src: "./img/researchLines/Francia/1.webp" },
    ],
  },
  {
  id: 20,
    titleKey: "texas_proj_title",
    titleText: "COE Internship: Autonomous University of Yucatan (UADY)",
    descriptionKey: "texas_proj_desc",
    descriptionText: "The internship will be hosted under the Robotics and Industry 4.0 Lab at UADY. UADY's Robotics and Industry 4.0 Lab's mission is to develop innovative systems that integrate cutting-edge technologies, such as alternative energy sources, nanostructured materials, wireless sensor networks, and artificial intelligence.",
    imageSrc: "./img/researchLines/Texas/11.jpg",
    showButton: false,
    category: "DOBLE TITULACIÓN · INTERNACIONAL",
    members: ["Kousuke Tood", "Zach Bauman", "Raul Mendoza","Caden D'Souza", "Sammip", "Yumil Rueda", "Pedro Casanova", "Francisco Bacab"],
    projectType: "internacional",
    gallery: [
      { type: "image", src: "./img/researchLines/Texas/1.jpg" },
      { type: "image", src: "./img/researchLines/Texas/2.jpg" },
      { type: "image", src: "./img/researchLines/Texas/3.jpg" },
    ],
  },
  // --- PROYECTOS PRINCIPALES DEL LAB ---
  {
    id: 1,
    titleKey: "granja_sub",
    titleText: "Granja de FPGAs Altera",
    descriptionKey: "granja_descr",
    descriptionText: "The Robotics and Industry 4.0 Laboratory of the Autonomous University of Yucatán (UADY) proposes to increase the training of human resources and research lines in VLSI circuit design and FPGA technology.",
    imageSrc: "./img/tesis/TesisMagana.png",
    showButton: false,
    category: "SISTEMAS DE ALTO RENDIMIENTO",
    members: ["Luis Magaña", "Pedro Casanova", "Francisco Bacab"],
    gallery: [
    { type: "image" as const, src: "./img/researchLines/Proyecto_1.png" },
    ],
    projectType: "investigacion",
  },
  {
    id: 2,
    titleKey: "sensado_sub",
    titleText: "Sensado seguro para materiales compuestos inteligentes",
    descriptionKey: "sensado_desc",
    descriptionText: "Research project developed at the Robotics and Industry 4.0 Laboratory of UADY, in collaboration with CICY, for the design of VLSI digital architectures that detect and estimate the piezoresistive and thermoresistive response of nanostructured composite materials.",
    imageSrc: "./img/researchLines/Proyecto_2.png",
    showButton: false,
    category: "MATERIALES INTELIGENTES",
    members: ["Yumil Rueda", "Marco González"],
    projectType: "investigacion",
  },

  // --- TESIS DE DOCTORADO ---
  {
    id: 3,
    titleKey: "doc1_proj_title",
    titleText: "Real-time simulation in nanostructured composites using Machine Learning and Digital Twins",
    descriptionKey: "doc1_proj_desc",
    descriptionText: "student_doc1_thesis_desc",
    imageSrc: "./img/tesis/Yumil/1.png",
    showButton: false,
    category: "DIGITAL TWINS · IA",
    members: ["Yumil Rueda"],
    gallery: [
      // { type: "image" as const, src: "./img/tesis/Yumil/1.png" },
      { type: "image" as const, src: "./img/tesis/Yumil/2.png" },
      { type: "image" as const, src: "./img/tesis/Yumil/3.png" },
      { type: "image" as const, src: "./img/tesis/Yumil/4.png" },
      { type: "image" as const, src: "./img/tesis/Yumil/5.png" },
    ],
    projectType: "tesis",
  },
  {
    id: 4,
    titleKey: "doc2_proj_title",
    titleText: "VLSI Cryptographic Controller for Wireless Sensor Networks",
    descriptionKey: "doc2_proj_desc",
    descriptionText: "student_doc2_thesis_desc",
    imageSrc: "./img/tesis/TesisGedao.jpeg",
    showButton: false,
    category: "CIBERSEGURIDAD · VLSI",
    members: ["Gedao Santos"],
    projectType: "tesis",
  },

  // --- TESIS DE MAESTRÍA ---
  {
    id: 5,
    titleKey: "mae1_proj_title",
    titleText: "Multimodal Prediction of Environmental Conditions in Smart Cities",
    descriptionKey: "mae1_proj_desc",
    descriptionText: "student_mae1_thesis_desc",
    imageSrc: "./img/tesis/TesisJorge2.jpeg",
    showButton: false,
    category: "IOT · SMART CITIES",
    members: ["Jorge Flores"],
    gallery: [
    { type: "image" as const, src: "./img/tesis/TesisJorge.jpeg" },
    { type: "image" as const, src: "./img/tesis/TesisJorge2.jpeg" },
    { type: "image" as const, src: "./img/tesis/TesisJorge3.jpeg" },
    ],
    projectType: "tesis",
},
{
  id: 6,
  titleKey: "mae2_proj_title",
  titleText: "VLSI Controller for Piezoresistive Estimation in Robotic Actuators",
  descriptionKey: "mae2_proj_desc",
  descriptionText: "student_mae2_thesis_desc",
  imageSrc: "./img/tesis/TesisMarco.png",
  showButton: false,
  category: "ROBÓTICA · VLSI",
  members: ["Marco González"],
  gallery: [
    { type: "image" as const, src: "./img/tesis/TesisMarco.png" },
    { type: "image" as const, src: "./img/tesis/TesisMarco2.png" },
    { type: "image" as const, src: "./img/tesis/TesisMarco3.png" },
    { type: "image" as const, src: "./img/tesis/TesisMarco4.png" },
    ],
  projectType: "tesis",
},
{
    id: 7,
    titleKey: "mae3_proj_title",
    titleText: "Mexican Sign Language Recognition Using Piezoresistive Sensors and Embedded AI",
    descriptionKey: "mae3_proj_desc",
    descriptionText: "student_mae3_thesis_desc",
    imageSrc: "./img/tesis/TesisFerrer.jpeg",
    showButton: false,
    category: "IA EMBEBIDA · BIOMÉDICA",
    members: ["Pedro Ferrer"],
    gallery: [
      { type: "image" as const, src: "./img/tesis/TesisFerrer.jpeg" },
      { type: "image" as const, src: "./img/tesis/TesisFerrer.jpeg" },
      ],
    projectType: "tesis",
  },
  {
    id: 8,
    titleKey: "mae4_proj_title",
    titleText: "Low-Power Cryptoprocessor Architecture for Wireless Sensor Networks",
    descriptionKey: "mae4_proj_desc",
    descriptionText: "student_mae4_thesis_desc",
    imageSrc: "./img/tesis/TesisMike.jpeg",
    showButton: false,
    category: "CRIPTOGRAFÍA · VLSI",
    members: ["Miguel Landero"],
    projectType: "tesis",
  },

  // --- TESIS DE LICENCIATURA ---
  {
    id: 9,
    titleKey: "lic1_proj_title",
    titleText: "Wearable Prototype for Non-Invasive Blood Glucose Estimation",
    descriptionKey: "lic1_proj_desc",
    descriptionText: "student_lic1_thesis_desc",
    imageSrc: "./img/tesis/TesisFelipe6.png",
    showButton: false,
    category: "BIOMÉDICA · IA",
    members: ["Felipe Sierra"],
    gallery: [
      { type: "image" as const, src: "./img/tesis/TesisFelipe6.png" },
      { type: "image" as const, src: "./img/tesis/TesisFelipe2.png" },
      { type: "image" as const, src: "./img/tesis/TesisFelipe3.png" },
      { type: "image" as const, src: "./img/tesis/TesisFelipe4.png" },
      { type: "image" as const, src: "./img/tesis/TesisFelipe5.png" },
      ],
    projectType: "tesis",
  },
  {
    id: 10,
    titleKey: "lic2_proj_title",
    titleText: "Architectural Reengineering of a Remote-Access FPGA Farm",
    descriptionKey: "lic2_proj_desc",
    descriptionText: "student_lic2_thesis_desc",
    imageSrc: "./img/tesis/TesisMagana.png",
    showButton: false,
    category: "FPGA · INFRAESTRUCTURA",
    members: ["Luis Magaña"],
    projectType: "tesis",

  },
  {
    id: 11,
    titleKey: "lic3_proj_title",
    titleText: "Neural Hardware Architecture for Piezoresistive Sensors on FPGA",
    descriptionKey: "lic3_proj_desc",
    descriptionText: "student_lic3_thesis_desc",
    imageSrc: "./img/tesis/TesisLuis.jpeg",
    showButton: false,
    category: "FPGA · REDES NEURONALES",
    members: ["Luis Navarro"],
    gallery: [
      { type: "image" as const, src: "./img/tesis/TesisLuis2.jpeg" },
      { type: "image" as const, src: "./img/tesis/TesisLuis3.jpeg" },
      { type: "image" as const, src: "./img/tesis/TesisLuis4.jpeg" },
      { type: "image" as const, src: "./img/tesis/TesisLuis5.jpeg" },
      ],
    projectType: "tesis",
  },
  {
    id: 12,
    titleKey: "lic4_proj_title",
    titleText: "Universal Testing Machine for Piezoresistive Characterization",
    descriptionKey: "lic4_proj_desc",
    descriptionText: "student_lic4_thesis_desc",
    imageSrc: "./img/tesis/TesisSebas.png",
    showButton: false,
    category: "SENSORES · MECATRÓNICA",
    members: ["Sebastián Patrón"],
    gallery: [
      { type: "image" as const, src: "./img/tesis/TesisSebas2.png" },
      ],
    projectType: "tesis",
  },
  {
    id: 13,
    titleKey: "lic5_proj_title",
    titleText: "Intelligent Agent for Automatic Resource Allocation in an FPGA Farm",
    descriptionKey: "lic5_proj_desc",
    descriptionText: "student_lic5_thesis_desc",
    imageSrc: "./img/tesis/TesisFrancisco.jpeg",
    showButton: false,
    category: "IA · FPGA",
    members: ["Francisco Bacab"],
    gallery: [
      { type: "image" as const, src: "./img/tesis/TesisFrancisco2.jpeg" },
      ],
    projectType: "tesis",
  },
  {
    id: 14,
    titleKey: "lic6_proj_title",
    titleText: "Piezoresistive Response of 2D MXene-Based Materials for Wearable Sensors",
    descriptionKey: "lic6_proj_desc",
    descriptionText: "student_lic6_thesis_desc",
    imageSrc: "./img/tesis/TesisGeorge.png",
    showButton: false,
    category: "MATERIALES · SENSORES",
    members: ["Jorge Pat"],
    gallery: [
      { type: "image" as const, src: "./img/tesis/TesisGeorge2.png" },
    ],
    projectType: "tesis",
  },
  {
    id: 15,
    titleKey: "lic7_proj_title",
    titleText: "Sediment Microbiological Cell for Autonomous Mangrove Monitoring",
    descriptionKey: "lic7_proj_desc",
    descriptionText: "student_lic7_thesis_desc",
    imageSrc: "./img/tesis/TesisTony2.jpeg",
    showButton: false,
    category: "IOT · MEDIOAMBIENTE",
    members: ["José Pech"],
    gallery: [
      { type: "image" as const, src: "./img/tesis/TesisTony.jpeg" },
    ],
    projectType: "tesis",
  },
  {
    id: 16,
    titleKey: "lic8_proj_title",
    titleText: "Intelligent Resource Management with Intel Agilex FPGA in a Reconfigurable Cluster",
    descriptionKey: "lic8_proj_desc",
    descriptionText: "student_lic8_thesis_desc",
    imageSrc: "./img/tesis/TesisPedro.png",
    showButton: false,
    category: "FPGA · HPC",
    members: ["Pedro Casanova"],
    projectType: "tesis",

  },
];